import { Component, OnInit } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { EnvconfigService } from 'src/app/core/service/envconfig.service';

@Component({
  selector: 'app-pagina401',
  templateUrl: './page401.component.html',
  styleUrls: ['./page401.component.css'],
  standalone: false
})
export class Page401Component implements OnInit {
  usuario!: string;
  constructor(   private environment: EnvconfigService) { }

  ngOnInit(): void {
    const helper = new JwtHelperService();
    let token = localStorage.getItem(this.environment.get("TOKEN_NAME"))!;
    helper.decodeToken(token);
  }

}